import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as encoding from 'encoding-japanese';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';

import { LocaStockService } from '../../../service/loca-stock/loca-stock.service';
import { TypeStockService } from '../../../service/type-stock/type-stock.service';
import { PdfReportService } from '../../../service/pdf-report/pdf-report.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { OwnerService } from '../../../service/owner/owner.service';
import { StockService } from '../../../service/stock/stock.service';

@Component({
  selector: 'app-root',
  templateUrl: 'wa6010.component.html',
  styleUrls: ['wa6010.component.scss']
})
export class Wa6010Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA6010:ロケ別在庫照会';

  // Common
  private sessionItemSelectedKey = 'itemSelected';
  private sessionItemKey = 'rowItem';
  // Specific
  private sessionHeadKey = 'wa6011-head';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public viewModes: any[];
  public viewMode = null;

  public ownerId: number;
  public ownerResult: any;
  private isOwnerLinked: boolean = false;

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for print
  public reporttrnId: number;
  private reportOpened = false;
  private reportTry = 0;
  private isShowRemoveModal = false;
  public url = '#';

  private errorInfo = '';

  private gridHelper: AgGridHelper;
  @ViewChild('mainGridView')
  mainGridView: ElementRef;

  private searchValue1 = null;
  private searchValue2 = null;
  private searchValue3:number = null;
  public stockTypes: any[];
  public stockType = '';
  private overlaydspnone: boolean = true;
  private selectownerId;
  private selectownerTx;
  private isEnableClearFilter = false;
  private isShowCommentEditor = false;
  public memoTx = new FormControl('', [Validators.maxLength(50)]);
  private commentEditorTypeSelected = null;
  private commentErrorInfo = '';
  private commentLocaStock = null;
  private commentOwnerId = null;
  private isCommentEditorUpdateButtonEnable = false;
  private selectedRowData = {};
  private selectedRowNode = {};
  private Selectoption: any;
  private ownerdisplayTx: any;
  private open_regist: boolean = false;
  private open_update: boolean = false;

  /** Instock modal */
  private isShowInStockModal = false;
  public ownerGridOptions: GridOptions;
  private ownerGridHelper: AgGridHelper;
  @ViewChild('ownerGridView')
  ownerGridView: ElementRef;
  public ownerRowData: any[];
  private ownerGridHeight = 300;
  private isEnableOwnerClearFilter = false;
  private ownerGridApi: any;

  private isShow6012 = false;
  private isShowSearchBlock = true;

  private isEnableRightSearchButtons = false;
  private isEnableSendMailButton = false;

  private isShow6011 = false;
  private paginationGetRowCount = 0;
  private paginationGetRowCount2 = 0;
  private selectedCount = 0;
  private selectedCount2 = 0;

  private searchValue1Cls = '';
  private searchValue2Cls = '';
  private stockTypeCls = '';
  private searchItemId = null;
  private isShowSendLoading = false;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  public rowsPerPage = config.rowsPerPageSize;
  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }, { value: 1000, viewValue: '1000' }];

  private gridSelectAll = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private locaStockService: LocaStockService,
    private pdfReportService: PdfReportService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private typeStockService: TypeStockService,
    private ownerService: OwnerService,
    private el: ElementRef,
    private stockService: StockService
  ) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -121;

    //SessionStorageからユーザ情報を取得、荷主ユーザか判定
    const loginResult = sessionStorage.getItem('loginResult');
    if (loginResult !== null) {
      let user = JSON.parse(loginResult).user;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
    }

    this.gridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      pagination: true,
      shohwLoadingOverlay: true,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa6010_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.fixedSelectAll()
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
        this.isEnableRightSearchButtons = false;
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        // this.isEnableRightSearchButtons = this.gridOptions.api.getSelectedRows().length > 0;
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
        this.handleRowSelected()
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();

        this.gridHelper.autoTogglePagination();

        if (this.gridSelectAll) {
          this.selectedCount = 0
          this.selectAllClick()
        }
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left',
        suppressMovable: true
      },
      {
        headerName: '',
        pinned: 'left',
        width: 104,
        cellClass: ['tc', 'cellclass'],
        cellStyle: this.isOwnerLinked?{ display: 'none' }:function (node) {
            if ((node.data.mixitemFl == 0 && node.data.stockNr > 0) ||
                (node.data.locaCd == null || node.data.locaCd.length === 0)) {
              return { display: 'none' };
            }
        },
        suppressMovable: true,
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '在庫登録',
          buttonStyle: this.isOwnerLinked? 'dspnone' : '',
          onClick: this.onLocalStockLoginButtonClick.bind(this)
        }
      },
      {
        headerName: 'ロケーション名',
        field: 'locaTx',
        sort: 'asc',
        width: this.getColumnWidth('locaTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション',
        field: 'locaCd',
        width: this.getColumnWidth('locaCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '倉庫コード',
        field: 'whCd',
        width: this.getColumnWidth('whCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'フロアコード',
        field: 'floorCd',
        width: this.getColumnWidth('floorCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'エリアコード',
        field: 'areaCd',
        width: this.getColumnWidth('areaCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '列コード',
        field: 'lineCd',
        width: this.getColumnWidth('lineCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '棚コード',
        field: 'shelfCd',
        width: this.getColumnWidth('shelfCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '段コード',
        field: 'layerCd',
        width: this.getColumnWidth('layerCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '番コード',
        field: 'orderCd',
        width: this.getColumnWidth('orderCd', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケ荷主コード',
        field: 'locaownerCd',
        width: this.getColumnWidth('locaownerCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケ荷主名',
        field: 'locaownerTx',
        width: this.getColumnWidth('locaownerTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '格納什器ケース名',
        field: 'shelfcaseTx',
        width: this.getColumnWidth('shelfcaseTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーションブロック名',
        field: 'locablockTx',
        width: this.getColumnWidth('locablockTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケ標準ケース',
        field: 'shelfcaseLocabaracaseTx',
        width: this.getColumnWidth('shelfcaseLocabaracaseTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケ標準ケースコード',
        field: 'shelfcaseLocabaracaseCd',
        width: this.getColumnWidth('shelfcaseLocabaracaseCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass'],
        filter: 'text'
      },
      {
        headerName: '温度帯',
        field: 'typecoldTx',
        width: this.getColumnWidth('typecoldTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケABC',
        field: 'locaabcTx',
        width: this.getColumnWidth('locaabcTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品標準ケース',
        field: 'locabaracaseTx',
        width: this.getColumnWidth('locabaracaseTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品標準ケースコード',
        field: 'locabaracaseCd',
        width: this.getColumnWidth('locabaracaseCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 300),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat'],
        cellRendererFramework: GridButtonRenderComponent,
        cellRendererParams: {
          buttonText: '在庫修正',
          itemFieldBeforeButton: 'itemCd',
          buttonStyle: this.isOwnerLinked? 'dspnone' : '',
          onClick: this.onLocalStockEditButtonClick.bind(this)
        }
      },
      {
        headerName: '商品カテゴリ',
        field: 'typeitemTx',
        width: this.getColumnWidth('typeitemTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ピースバーコード',
        field: 'pcsbarcodeTx',
        width: this.getColumnWidth('pcsbarcodeTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: 'ケースバーコード',
        field: 'casebarcodeTx',
        width: this.getColumnWidth('casebarcodeTx', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass', 'textFormat']
      },
      {
        headerName: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '期限切迫残日数',
        field: 'deadlinedaysNr',
        width: this.getColumnWidth('deadlinedaysNr', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入庫日',
        field: 'stockDt',
        width: this.getColumnWidth('stockDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '標準ｹｰｽ入数',
        field: 'baraamountNr',
        width: this.getColumnWidth('baraamountNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ｹｰｽ入数',
        field: 'caseamountNr',
        width: this.getColumnWidth('caseamountNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ｲﾝﾅｰｹｰｽ数',
        field: 'innerNr',
        width: this.getColumnWidth('innerNr', 130),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ｲﾝﾅｰｹｰｽ入数',
        field: 'inneramountNr',
        width: this.getColumnWidth('inneramountNr', 140),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ﾊﾟﾚｯﾄ段数',
        field: 'casespreadNr',
        width: this.getColumnWidth('casespreadNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: 'ﾊﾟﾚｯﾄ巻数',
        field: 'casestackNr',
        width: this.getColumnWidth('casestackNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '在庫数(ｹｰｽ)',
        field: 'stockcaseNr',
        width: this.getColumnWidth('stockcaseNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '在庫数(ｲﾝﾅｰｹｰｽ)',
        field: 'stockinnerNr',
        width: this.getColumnWidth('stockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '在庫数(ﾊﾞﾗ)',
        field: 'stockpcsNr',
        width: this.getColumnWidth('stockpcsNr', 130),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当理由',
        field: 'ststockTx',
        width: this.getColumnWidth('ststockTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '在庫数',
        field: 'stockNr',
        width: this.getColumnWidth('stockNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当可能数(ｹｰｽ)',
        field: 'pstockcaseNr',
        width: this.getColumnWidth('pstockcaseNr', 130),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当可能数(ｲﾝﾅｰｹｰｽ)',
        field: 'pstockinnerNr',
        width: this.getColumnWidth('pstockinnerNr', 150),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当可能数(ﾊﾞﾗ)',
        field: 'pstockpcsNr',
        width: this.getColumnWidth('pstockpcsNr', 130),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当可能数',
        field: 'pstockNr',
        width: this.getColumnWidth('pstockNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当済数(ｹｰｽ)',
        field: 'cstockcaseNr',
        width: this.getColumnWidth('cstockcaseNr', 100),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当済数(ｲﾝﾅｰｹｰｽ)',
        field: 'cstockinnerNr',
        width: this.getColumnWidth('cstockinnerNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当済数(ﾊﾞﾗ)',
        field: 'cstockpcsNr',
        width: this.getColumnWidth('cstockpcsNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '引当済数',
        field: 'cstockNr',
        width: this.getColumnWidth('cstockNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '標準ケース数',
        field: 'baracaseNr',
        width: this.getColumnWidth('baracaseNr', 120),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '引当設定',
        field: 'notapplyFl',
        width: this.getColumnWidth('notapplyFl', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '備考',
        field: 'stockmemotTx',
        width: this.getColumnWidth('stockmemotTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      // 集約して表示するため、管理項目は表示できない
      {
        field: 'locaId',
        hide: true
      },
      {
        field: 'itemunitId',
        hide: true
      }
    ];
    this.gridOptions.excelStyles = [
      {
        //Text
        id: 'textFormat',
        dataType: 'string'
      }
    ];
    this.gridHelper.setGridOptions(this.gridOptions);

    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }

    this.initOwnerGrid();
    this.viewModes = [{ id: 0, text: 'すべて' }, { id: 1, text: 'あり' }, { id: 2, text: 'なし' }];

    //this.viewMode = 0;
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa6010_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa6010_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa6010_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.mainGridView;
    this.ownerGridHelper.el = this.ownerGridView;
    const clear = this.route.snapshot.queryParamMap.get('clear');

    if (clear === '1') {
      sessionStorage.removeItem('wa6030_itemId');
    }

    this.gridOptions.api.setRowData([]);

    this.typeStockService
      .get()
      .then(response => {
        console.log(response);
        this.stockTypes = response['typestocks'];
      })
      .catch(error => {
        this.stockTypes = [];
      });

    var itemCd = sessionStorage.getItem('wa6030_itemId');
    if (itemCd != null) {
      sessionStorage.removeItem('wa6030_itemId');

      setTimeout(() => {
        // this.searchItemId = itemCd;
        this.searchValue2 = itemCd;
        this.onSubmit();
      }, 500);
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  onClear() {
    // 検索クリアは、絞り込み条件をクリアします。
    sessionStorage.removeItem('wa6030_itemId');
    this.onSubmit();
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.gridOptions.api.showLoadingOverlay();
    //const itemId = +sessionStorage.getItem('wa6030_itemId');
    this.locaStockService
      .get(
        this.viewMode,
        this.searchItemId,
        this.ownerId,
        this.searchValue1,
        this.searchValue2,
        this.searchValue3,
        this.stockTypes[this.stockType] && this.stockTypes[this.stockType]['typestockCd'] || null
      )
      .then(outputJson => {

        //console.log(JSON.stringify(outputJson));
        this.rowData = outputJson.locastocks;

        //start = wa6011-Data;
        this.Selectoption = outputJson.locastocks;
        // wa6011-ownerTx ? is all | one;
        var ownerId: string = '';
        var _ownerId: string = '';
        var SelectownerId = [];
        var SelectownerTx = [];

        var ownerIds = [];
        var ownerTxs = [];
        for (let i = 0; i < this.Selectoption.length; i++) {
          ownerId += this.Selectoption[i].ownerId;
          _ownerId += this.Selectoption[0].ownerId;
          ownerIds.push(this.Selectoption[i].ownerId);
          ownerTxs.push(this.Selectoption[i].ownerTx);
        }
        for (let i = 0; i < ownerIds.length; i++) {
          if (SelectownerId.indexOf(ownerIds[i]) < 0) {
            SelectownerId.push(ownerIds[i]);
          }
          if (SelectownerTx.indexOf(ownerTxs[i]) < 0) {
            SelectownerTx.push(ownerTxs[i]);
          }
        }
        this.ownerdisplayTx = [];
        for (let i = 0; i < SelectownerId.length; i++) {
          this.ownerdisplayTx[i] = { ownerId: SelectownerId[i], ownerTx: SelectownerTx[i] };
        }

        if (ownerId !== _ownerId) {
          sessionStorage.setItem('ownerTx', 'ALL');
        } else {
          sessionStorage.removeItem('ownerTx');
          if (this.ownerdisplayTx.length === 0) {
            sessionStorage.setItem('ownerTxError', 'true');
            sessionStorage.setItem('ownerTxErrinfo', JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx);
          } else {
            sessionStorage.removeItem('ownerTxError');
            sessionStorage.removeItem('ownerTxErrinfo');
            if (sessionStorage.getItem('ownerResult') != null)
              sessionStorage.setItem('SessionOwnerId', JSON.parse(sessionStorage.getItem('ownerResult')).ownerId);
          }
        }

        // Observable.timer(100).subscribe(() => {
        //   this.searchByKey();
        //   this.gridHelper.selectedAnimate();
        // });
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working = false;
        },300);
      })
      .catch(error => {
        this.working = false;
        this.gridOptions.api.hideOverlay();
        sessionStorage.setItem('ownerTx', 'ALL');
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  regStock() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    } else {
      sessionStorage.removeItem(this.sessionItemSelectedKey);
      sessionStorage.removeItem(this.sessionItemKey);
      sessionStorage.removeItem(this.sessionHeadKey);
      //
      const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
      sessionStorage.setItem('rowLocaStock', JSON.stringify(this.rowData[selectedIndex]));
      sessionStorage.setItem('ownerId', String(this.ownerId));
      sessionStorage.setItem('itemSelected', '0');
      this.router.navigate(['wa6011']);
    }
  }

  updStock() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    } else {
      const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
      const itemCd: string = this.rowData[selectedIndex]['itemCd'];
      const pstockNr: number = this.rowData[selectedIndex]['pstockNr'];

      if (itemCd === null) {
        this.errorInfo = '選択されたロケに商品が登録されていません';
      } else if (pstockNr <= 0) {
        this.errorInfo = '修正する場合は在庫が存在する行を選択して下さい';
      } else {
        sessionStorage.setItem('rowLocaStock', JSON.stringify(this.rowData[selectedIndex]));
        this.router.navigate(['wa6012']);
      }
    }
  }

  printKanban() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.isShowSendLoading = true;
    this.errorInfo = '';
    if (!this.isEnableRightSearchButtons) return;

    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      this.isShowSendLoading = false;
      this.working = false;
      return;
    }
    // Change the flag of working to true in order to disable the submit button
    const selectIds: object[] = [];
    for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
      const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
      const jsonUnit: object = {
        selectId: this.rowData[rowIndex]['locastockpId']
      };
      selectIds.push(jsonUnit);
    }
    console.log(selectIds);
    // Reset the flag to indicate that the report has not been opened yet
    this.reportOpened = false;
    // Reset the limit counter
    this.reportTry = 0;
    // Submit the request to generate the report
    this.pdfReportService
      .post(0, 'TA_LOCASTOCKP', 'RA9001', 0, 'wa6010', selectIds)
      .then(outputJson => {
        this.reporttrnId = outputJson.reporttrnId;
        // Call the PDF report service
        this.pdfReportService
          .printReport('RA9001', this.reporttrnId)
          .then(outputJson => {
              // Change the working flag to false in order to enable the submit button
              this.working = false;
			  this.isShowSendLoading = false;
              const url = environment.pdfPath + outputJson.pdfFilename;
              this.openReport(url);
          })
          .catch(error => {
            // Change the working flag to false in order to enable the submit button
            this.working = false;
			this.isShowSendLoading = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.isShowSendLoading = false;
      });
  }

  waitResult() {
    const obs = Observable.interval(1000).subscribe(() => {
      // Verify that we have not tried more than 10 times
      if (this.reportTry <= 10) {
        // Add a new try to the counter
        this.reportTry++;
        // Call the PDF report service
        this.pdfReportService
          .get(this.reporttrnId)
          .then(outputJson => {
            // seems we can get the report path correctly
            // If the createdFl is 0 the report has not finished so we retry again.
            // If the createdFl is 1 we get the report name and open a new window to show the PDF file.
            if (outputJson.reports[0].createdFl === 1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              // Change the working flag to false in order to enable the submit button
              this.working = false;
              const url = environment.bucketUrl + '/report/' + outputJson.reports[0].reportpathTx;
              // We open a new tab to display the PDF.
              // If preferred we could get the PDF data and send the blob to the new tab instead.
              this.openReport(url);
            }
            if (outputJson.reports[0].createdFl === -1) {
              // Cancel the Observable when success
              obs.unsubscribe();
              this.working = false;
              this.errorInfo = '対象データがないため帳票が作成できませんでした';
            }
          })
          .catch(error => {
            // Cancel the Observable in case of error
            obs.unsubscribe();
            // Change the working flag to false in order to enable the submit button
            this.working = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      } else {
        // Cancel the Observable if the number of tries maxed out
        obs.unsubscribe();
        // Change the working flag to false in order to enable the submit button
        this.working = false;
        this.errorInfo = '帳票を取得できませんでした（タイムアウト）。再発する場合は管理者へ連絡してください';
      }
    });
  }

  // Open the newly generated report on a different tab/window
  openReport(url) {
    // Verify that the report has not been opened already in cases where the network response is slow
    // and we get multiple responses at the same time.
    if (this.reportOpened === false) {
      this.url = url;
      this.isShowRemoveModal = true;
      // Change the flag to indicate that the report was already opened
      this.reportOpened = true;
    }
  }

  confirmOk() {
    const popup_window = window.open(this.url);
    try {
      popup_window.focus();
    } catch (e) {
      this.isShowRemoveModal = false;
    }
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];
      this.gridOptions.api.deselectAll();
    }

    this.requestOwners();
  }

  sendResult() {
    this.router.navigate(['wa6014']);
  }

  searchByKey() {
    var filters = {};
    if (this.searchValue1 != null && this.searchValue1.length > 0) {
      filters['locaCd'] = {
        type: 'contains',
        filter: this.searchValue1
      };
    }

    if (this.searchValue2 != null && this.searchValue2.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.searchValue2
      };
    }

    if (this.searchValue3 != null) {
      filters['deadlinedaysNr'] = {
        type: 'lessThanOrEqual',
        filter: this.searchValue3
      };
    }

    if (this.stockType != null && this.stockType.length > 0) {
      filters['typestockTx'] = {
        type: 'equals',
        filter: this.stockTypes[this.stockType]['typestockTx']
      };
    }
    this.gridOptions.api.setFilterModel(null);

    if (Object.getOwnPropertyNames(filters).length == 0) return;

    this.gridApi.api.setFilterModel(filters);
  }

  clearSearchKey() {
    this.errorInfo = '';

    this.viewMode = null;
    this.searchValue1 = null;
    this.searchValue2 = null;
    this.searchValue3 = null;
    this.stockType = '';
  }

  clearFilter() {
    this.errorInfo = '';

    this.gridOptions.api.setFilterModel(null);
  }

  clearAndSubmit() {
    this.errorInfo = '';

    this.selectedCount = 0;
    this.clearFilter();
    this.onSubmit();
  }

  /** Start CommentEditor */
  showCommentEditor() {
    this.errorInfo = '';
    this.commentErrorInfo = '';

    if (!this.isEnableRightSearchButtons) return;

    if (this.gridOptions.api.getSelectedNodes().length === 0) {
      this.errorInfo = '対象を選択して下さい';
      return;
    } else {
      // Change the flag of working to true in order to disable the submit button
      //this.working = true;
      let ownerId: number;
      const selectIds: object[] = [];
      for (let i = 0; i < this.gridOptions.api.getSelectedNodes().length; i++) {
        const rowIndex: number = +this.gridOptions.api.getSelectedNodes()[i]['id'];
        const itemCd: String = this.rowData[rowIndex]['itemCd'];
        if (!itemCd) {
          //this.working = false;
          this.errorInfo = '修正する場合は在庫が存在する行を選択して下さい';
          return;
        }
        if (i === 0) {
          ownerId = this.rowData[rowIndex]['ownerId'];
        }
        const jsonUnit: object = {
          selectId: this.rowData[rowIndex]['locastockpId']
        };
        selectIds.push(jsonUnit);
      }
      console.log(JSON.stringify(selectIds));

      this.commentLocaStock = selectIds;
      this.commentOwnerId = ownerId;
    }
    this.commentEditorTypeSelected = null;
    this.isCommentEditorUpdateButtonEnable = false;
    this.isShowCommentEditor = true;
    this.memoTx.setValue('');
  }

  changeCommentEditorSelectType() {
    this.isCommentEditorUpdateButtonEnable = this.commentEditorTypeSelected != null;
  }

  changeMemoTx() {
    // this.isCommentEditorUpdateButtonEnable = this.memoTx.value !== null;
  }

  updateCommentEditor() {
    this.working = true;
    if (this.commentEditorTypeSelected == null) {
      this.working = false;
      this.commentErrorInfo = '出荷引当を選択してください';
      return;
    }

    if (this.memoTx.value && this.memoTx.value.length > 50) {
      this.working = false;
      this.commentErrorInfo = '備考は50文字以下で入力してください';
      return;
    }

    this.locaStockService
      .updStockMemo(this.commentLocaStock, this.commentOwnerId, this.commentEditorTypeSelected, this.memoTx.value, 'wa6013')
      .then(outputJson => {
        console.log(outputJson);

        this.working = false;
        this.isShowCommentEditor = false;
        this.memoTx.setValue('');
        this.commentEditorTypeSelected = null;
        this.onSubmit();
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.commentErrorInfo = this.commonService.getErrorMessage(error);
      });
  }
  /** End CommentEditor */

  /** Start localStock login */
  onLocalStockLoginButtonClick(node, $event) {
    event.stopPropagation();

    this.errorInfo = '';
    var rowIndex = node.id;
    this.selectedRowData = this.rowData[rowIndex];
    this.selectedRowNode = node;

    sessionStorage.removeItem('isShowOwnerSelect');
    this.isShow6011 = true;
  }
  /** End localStock login */

  /** Start localStock Edit */
  onLocalStockEditButtonClick(node) {
    this.errorInfo = '';
    if (node.data.pstockNr <= 0) {
      this.errorInfo = '修正する場合は在庫が存在する行を選択して下さい';
      return;
    }
    var rowIndex = node.id;
    this.selectedRowData = this.rowData[rowIndex];
    this.selectedRowNode = node;
    sessionStorage.setItem('rowLocaStock', JSON.stringify(this.rowData[rowIndex]));
    sessionStorage.removeItem('isShowOwnerSelect');
    this.isShow6012 = true;
  }
  /** End localStock Edit */

  /** InStock Modal */
  showInStockModal() {
    this.onOwnerFilterClear();
    this.errorInfo = '';

    if (this.ownerId === undefined) {
      this.isShowInStockModal = true;
      this.requestOwners();
    } else {
      this.selectownerId = JSON.parse(sessionStorage.getItem('ownerResult')).ownerId;
      this.selectownerTx = JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx;
      this.overlaydspnone = false;
    }
  }

  requestOwners() {
    // const ownerResult = sessionStorage.getItem('ownerResult');
    // if (ownerResult !== null) {
    //   const selectedOwner = JSON.parse(ownerResult);
    //   this.ownerRowData = [selectedOwner];
    //   this.ownerGridHeight = this.ownerGridHelper.getElementHeight(this.el.nativeElement.querySelector('.modal-content__tablearea'));
    //   return;
    // }
    this.selectedCount2 = 0;
    this.ownerService
      .get()
      .then(outputJson => {
        this.ownerRowData = outputJson.owners;
        this.ownerGridHeight = this.ownerGridHelper.getElementHeight(this.el.nativeElement.querySelector('.modal-content__tablearea'));
      })
      .catch(error => {
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  onOwnerFilterClear() {
    this.ownerGridOptions.api.setFilterModel(null);
  }

  saveOwnerColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa6014_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveOwnerColumnOrder() {
    let idx = 0;
    for (const column of this.ownerGridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa6014_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getOwnerColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa6014_${id}_width`), 10) || def;
  }

  initOwnerGrid() {
    this.ownerGridHelper = new AgGridHelper();
    // this.ownerGridHelper.gridSelectionCheckboxStyle = 'radio';
    this.ownerGridOptions = <GridOptions>{
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveOwnerColumnWidth,
      pagination: true,
      onColumnMoved: () => {
        this.saveOwnerColumnOrder();
      },
      onGridReady: params => {
        this.ownerGridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa6014_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.ownerGridHelper.onGridReady();
      },
      onFilterChanged: () => {
        this.isEnableOwnerClearFilter = this.ownerGridOptions.api.isAnyFilterPresent();
        this.ownerGridHelper.onGridFilterChanged();
        this.errorInfo = '';
      },
      onRowDataChanged: () => {
        this.ownerGridHelper.onRowDataChanged();
        this.errorInfo = '';

        if (this.ownerGridOptions.rowData && this.ownerGridOptions.rowData.length > 0) this.ownerGridHelper.isShowGridNoDataOverlay = false;
        else this.ownerGridHelper.isShowGridNoDataOverlay = true;
        this.isEnableSendMailButton = false;
      },
      overlayLoadingTemplate: this.ownerGridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.ownerGridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.ownerGridHelper.fixedAgMenu();
        this.errorInfo = '';
      },
      onSortChanged: () => {
        this.ownerGridHelper.renderGridCheckboxImage();
        this.errorInfo = '';
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.isEnableSendMailButton = this.ownerGridOptions.api.getSelectedRows().length > 0;
        this.selectedCount2 = this.ownerGridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.paginationGetRowCount2 = this.ownerGridOptions.api.paginationGetRowCount();
        this.ownerGridHelper.renderGridCheckboxImage();
      }
    };
    this.ownerGridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 40,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true,
        cellClass: ['tc', 'noCellFocus']
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getOwnerColumnWidth('ownerCd', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getOwnerColumnWidth('ownerTx', 560),
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.ownerGridHelper.setGridOptions(this.ownerGridOptions);
  }

  sendOwnerResult() {
    this.isShowSendLoading = true;

    if (this.ownerId === undefined) {
      this.isShowInStockModal = false;
      const selectItems: object[] = [];
      for (let i = 0; i < this.ownerGridOptions.api.getSelectedNodes().length; i++) {
        const rowIndex: number = +this.ownerGridOptions.api.getSelectedNodes()[i]['id'];
        const jsonUnit: object = {
          ownerId: this.ownerRowData[rowIndex]['ownerId']
        };
        selectItems.push(jsonUnit);
      }
      this.stockService
        .sendResult(selectItems, 'wa6014')
        .then(outputJson => {
          sessionStorage.setItem('SuccessInfoMessage', '在庫実績を送信しました。');
          this.isShowSendLoading = false;
          // this.isShowInStockModal = false;
        })
        .catch(error => {
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
        });
    } else {
      this.overlaydspnone = true;
      const selectItem: object[] = [];
      const jsonUnit: object = {
        ownerId: this.selectownerId
      };
      selectItem.push(jsonUnit);
      this.stockService
        .sendResult(selectItem, 'wa6014')
        .then(outputJson => {
          sessionStorage.setItem('SuccessInfoMessage', '在庫実績を送信しました。');
          this.isShowSendLoading = false;
        })
        .catch(error => {
          console.log(this.commonService.getErrorMessage(error));
          this.errorInfo = this.commonService.getErrorMessage(error);
          this.isShowSendLoading = false;
        });
    }
  }

  onClose6012(isCloseAndRefreshGrid: boolean) {
    this.isShow6012 = false;
    if (isCloseAndRefreshGrid) this.onSubmit();
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  onClose6011(isCloseAndRefreshGrid: boolean) {
    this.isShow6011 = false;
    if (isCloseAndRefreshGrid) {
      this.gridHelper.prepareSelectedAnimateByNodes([this.selectedRowNode]);
      this.onSubmit();
    }
    sessionStorage.setItem('isShowOwnerSelect', 'true');
  }

  onSearchBlockClick() {
    this.errorInfo = '';

    this.isShowSearchBlock = !this.isShowSearchBlock;
    this.gridHelper.renderScrollArrowDelay();
  }

  ngDoCheck() {
    /*
    if (sessionStorage.getItem('SuccessInfoMessage') == '在庫実績を送信しました。') {
      this.loading = true;
    } else {
      this.loading = false;
    }
    */
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  clrErr() {
    this.errorInfo = '';
  }

  handleRowSelected () {
    const selectedRows = this.gridOptions.api.getSelectedRows()
    const emptyStocks = selectedRows.filter(row => row.pstockNr === 0)
    this.isEnableRightSearchButtons = selectedRows.length > 0 && emptyStocks.length === 0
  }
  paginatorRowChange() {
    this.gridOptions.cacheBlockSize = Number(this.rowsPerPage);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.gridOptions.api.onSortChanged();
    localStorage.setItem('wa6010_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  fixedSelectAll() {
    var selectAll = this.mainGridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.classList.remove('ag-hidden')
    selectAll.addEventListener('click', () => {
      const nodes = this.gridOptions.api.getRenderedNodes()
      if (nodes.length > 0 && nodes[0].data === null) {
        this.gridSelectAll = !this.gridSelectAll
        return
      }

      this.gridSelectAll = !this.gridSelectAll
      nodes.forEach(node => {
        node.setSelected(this.gridSelectAll)
      })
    })
  }

  selectAllClick () {
    var selectAll = this.mainGridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.click()
  }
}





// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6010/wa6010.component.ts